"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var capitalRecordApi = _interopRequireWildcard(require("@/api/capitalRecordApi.js"));
var productSetting = _interopRequireWildcard(require("@/api/productSetting.js"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _store = require("@/api/store");
var _editBrank = _interopRequireDefault(require("./editBrank.vue"));
var _editProduct = _interopRequireDefault(require("./editProduct.vue"));
var _batchAmt = _interopRequireDefault(require("./batchAmt.vue"));
var _selectProducts = _interopRequireDefault(require("./selectProducts.vue"));
var _componentsApi = require("@/api/componentsApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditBrank: _editBrank.default,
    EditProduct: _editProduct.default,
    BatchAmt: _batchAmt.default,
    SelectProducts: _selectProducts.default
  },
  props: {
    fromType: [Number, String]
  },
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      visibleDrawer: false,
      //是否为展开
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      // 分类
      constants: this.$constants,
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      editDialogConfig: {
        visible: false,
        editId: 0,
        uploadFile: null
      },
      detailDialogConfig: {
        visible: false,
        editId: 0
      },
      recordDetail: {},
      initDetail: {}
    }, "props", {
      children: 'child',
      label: 'name',
      value: 'id',
      emitPath: false
    }), "merCateList", []), "selectIds", []), "selectLists", []), "excelData", []);
  },
  mounted: function mounted() {
    this.getCategorySelect();
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: {
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('supplier_product.xlsx');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = {};
            case 2:
              res = _t;
              toolUtils.downloadFile(res.fileName, '产品批量修改模版');
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    // 打开
    initOpen: function initOpen(row) {
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      productSetting.getproductList(_objectSpread(_objectSpread({}, pram), {}, {
        supplierId: this.initDetail.id
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 获取详情
    handlerOpenSetting: function handlerOpenSetting(editId) {
      var _this2 = this;
      this.recordDetail = {};
      capitalRecordApi.getComDetail(editId).then(function (res) {
        _this2.recordDetail = res || {};
        _this2.detailDialogConfig.visible = true;
      });
    },
    // 多选框选中数据
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectIds = selection.map(function (item) {
        return item.id;
      });
      this.selectLists = selection || [];
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    },
    // 导入修改弹窗
    handlerOpenEdit: function handlerOpenEdit() {
      this.editDialogConfig.url = '';
      this.editDialogConfig.visible = true;
      this.excelData = [];
    },
    // 确认导入修改
    submitImport: function submitImport() {
      var _this$editDialogConfi,
        _this4 = this;
      if (!((_this$editDialogConfi = this.editDialogConfig) !== null && _this$editDialogConfi !== void 0 && _this$editDialogConfi.url)) {
        this.$message.warning('请上传文件！');
        return;
      }
      ;
      productSetting.AddArticle({
        url: this.editDialogConfig.url,
        supplierId: this.initDetail.id
      }).then(function (res) {
        _this4.$message.success('操作成功！');
        _this4.handlerGetListData(_objectSpread({}, _this4.listPram));
        _this4.editDialogConfig.visible = false;
        _this4.detailDialogConfig.visible = false;
      });
    },
    // 批量移除
    batchRemove: function batchRemove(removeIds) {
      var _this5 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        productSetting.DelArticle(removeIds).then(function (data) {
          _this5.$message.success('删除数据成功');
          _this5.handlerGetListData(_this5.listPram);
          _this5.selectIds = [];
          _this5.selectLists = [];
        });
      });
    },
    // 批量移除
    remove: function remove(removeIds) {
      var _this6 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        productSetting.DelArticle(removeIds).then(function (data) {
          _this6.$message.success('删除数据成功');
          _this6.handlerGetListData(_this6.listPram);
          _this6.selectIds = [];
          _this6.selectLists = [];
        });
      });
    },
    // 关联品牌
    bindBrand: function bindBrand() {
      this.$refs.editBrankRef.openInit(this.initDetail.id);
    },
    // 产品信息设置
    editProductSetting: function editProductSetting(goodsId) {
      this.$refs.editProductRef.openInit(goodsId);
    },
    // 批量改价
    batchAmtEdit: function batchAmtEdit() {
      this.$refs.batchAmtRef.openInit(this.selectLists, this.initDetail.id);
    },
    // 选择商品
    addProducts: function addProducts() {
      this.$refs.selectProductsRef.openInit(this.initDetail.id);
    },
    // 上传文件
    onSuccess: function onSuccess(excelData) {
      var results = excelData.results;
      var arr = [];
      results.forEach(function (item, index) {
        if (index !== 0) {
          var values = Object.values(item);
          arr.push({
            id: values[0]
          });
        }
      });
      this.excelData = arr.length && arr.map(function (item) {
        return item.id;
      });
      this.$message.success('上传成功');
    }
  }
};